export function normalizeSelection(values = []) {
  return [...new Set(values.map(Number).filter((id) => Number.isFinite(id) && id > 0))]
}

export function filterOptions(options = [], query = '') {
  const needle = query.trim().toLowerCase()
  if (!needle) return options
  return options.filter((option) => (
    `${option.label} ${option.details || ''} ${option.id}`.toLowerCase().includes(needle)
  ))
}

export function toggleSelection(current, optionIds, checked) {
  const values = new Set(normalizeSelection(current))
  for (const id of normalizeSelection(optionIds)) {
    if (checked) values.add(id)
    else values.delete(id)
  }
  return [...values]
}

export function selectionState(current, optionIds) {
  const selected = new Set(normalizeSelection(current))
  const visible = normalizeSelection(optionIds)
  const count = visible.filter((id) => selected.has(id)).length
  return {
    count,
    all: visible.length > 0 && count === visible.length,
    some: count > 0 && count < visible.length,
  }
}
